import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { selectLogoFileUrl } from '@app/common/session/session.selectors';
import ThemeContext from '@app/providers/contexts/ThemeContext';
import { State } from '@app/store/root-reducer';
import { actionCreators } from '@app/common/auth/auth.reducer';
import { DefaultLogoSvg } from './default-logo.svg';
import EthicaLogo from '@app/bgimages/ethica-logo-white.svg';

interface ThemeContextType {
  theme: string;
  setTheme: (theme: string) => void;
}

export const Logo: React.FC = () => {
  const { theme } = React.useContext(ThemeContext) as ThemeContextType;
  const dispatch = useDispatch();
  const handleClick = () => dispatch(push('/dashboard'));
  const logoUrlFromSelector = useSelector(selectLogoFileUrl);
  const [imgError, setImgError] = React.useState(false);

  const handleImageError = () => {
    if (!imgError) {
      setImgError(true);


      if (logoUrlFromSelector && logoUrlFromSelector !== EthicaLogo) {
        dispatch(actionCreators.tokenRefreshRequest());
      }
    }
  };

  React.useEffect(() => {
    if (imgError && logoUrlFromSelector && logoUrlFromSelector !== EthicaLogo) {
      setImgError(false);
    }
  }, [logoUrlFromSelector, imgError]);


  if ((imgError && logoUrlFromSelector !== EthicaLogo) || logoUrlFromSelector === EthicaLogo) {
    return (
      <div onClick={handleClick} style={{ cursor: 'pointer', width: '200px' }}>
        <DefaultLogoSvg isDark={theme === 'dark'} />
      </div>
    );
  }


  return (
    <img 
      src={logoUrlFromSelector} 
      width="150px" 
      height="auto" 
      onClick={handleClick} 
      alt="Orchestrator Logo" 
      onError={handleImageError}
    />
  );
};
